<script setup lang="ts">
const hasPulse = ref(true);

const showMessage = ref(true);

const onClick = () => {
  hasPulse.value = false;
  showMessage.value = false;
};
</script>

<template>
  <div class="widget-button">
    <WidgetButtonMessage class="message" :enabled="showMessage" @click="onClick"
      >Klik hier om met mij te chatten.</WidgetButtonMessage
    >
    <WidgetButtonPulse class="avatar" :enabled="hasPulse" @click="onClick">
      <AssistantAvatar variant="button" />
    </WidgetButtonPulse>
  </div>
</template>

<style lang="scss" scoped>
.widget-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  pointer-events: none;

  > * {
    pointer-events: all;
  }
}

.message {
  cursor: pointer;
}

.avatar {
  position: relative;
  width: 60px;
  cursor: pointer;
}
</style>
